import { StandaloneLink } from '~/ComponentsTW/wm';
import uploadBridgeDevicesExample from '~/files/upload_bridge_devices.csv';
import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/sites';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const UploadBridgeDevices = ({ siteId }) => {
    const dispatch = useDispatch();
    const uploading = useSelector(state => state.sites.uploadingDevices);
    const uploadBridgeDevices = (siteId, file) => dispatch(actions.uploadBridgeDevices(siteId, file));

    const formSchema = [
        {
            accept: 'text/csv\n',
            label: 'File\x2a',
            name: 'file',
            type: 'file',
            validate: [validators.required]
        }
    ];

    const onSubmit = values => {
        const data = serializeForm(values, formSchema);
        uploadBridgeDevices(siteId, data.file);
    };

    return (
        <FormViewer label="Upload Bridge Devices File">
            <StandaloneLink download="upload_bridge_devices.csv" href={uploadBridgeDevicesExample} text="Download example file"/>
            <br/>
            <br/>
            <Form
                buttonLabel="Upload"
                formSchema={formSchema}
                isSubmitting={uploading}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default UploadBridgeDevices;
